import { cloneDeep } from 'lodash';

// No.15: 追加資料管理一覧のソート状態（一覧→詳細→戻り時の維持用）。
// filter/currentPage 等の他状態は cmsApplicationSearch を共用しており、
// 本ストアは sortBy/sortDesc のみを保持する最小構成。
const INIT_STATE = {
  sortBy: 'kana',
  sortDesc: false,
  preserveFilter: false,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_STATE),
  mutations: {
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
    setSort(state, { sortBy, sortDesc }) {
      state.sortBy = sortBy;
      state.sortDesc = sortDesc;
    },
    setPreserveFilter(state, v) {
      state.preserveFilter = v;
    },
    initFilter(state) {
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
  },
  actions: {
  },
};
